// extracted by mini-css-extract-plugin
module.exports = {"bb-image-with-caption":"bb-image-with-caption__VXVfv","caption":"caption__agZwa"};